// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#layout_168[data-v-05902318]{padding-top:72px}@media (max-width:767px){#layout_168[data-v-05902318]{padding-top:60px}}", ""]);
// Exports
module.exports = exports;
